module.exports = __webpack_public_path__ + "media/images/games/35reveal/sideways-01790e726fbaeb55b8a8b9e300daf33d.png";